export const projects = [
  {
    title: "High Rise Records",
    subtitle: "PERN Stack",
    description:
      "This is a model of a record store. High Rise Records used React, Express, Bootstrap, Sequelize, RESTful APIs, Redux, Node.js, Bcrpyt, JWT, Webpack, Faker.js, and the LastFM API. The store has Admin, logged-in user, and guest user capabilities. We also offer a persistent cart so users can check back in with the albums they were shopping for.",
    image: "./highrise.gif",
    link: "https://high-rise-records.onrender.com/",
  },
  {
    title: "Open Road",
    subtitle: "React, Firebase, and Mapbox GL JS",
    description:
      "Open Road is a navigation platform designed for motorcycle riders. Open Road renders 3d visualizations of popular routes using Mapbox GL JS and FreeCamera API, giving a birds-eye view of the planned route. Firebase was utilized to host our data (users, trips, and comments), as well as connect that data to our front end React components.",
    image: "./openroad.gif",
    link: "https://open-road-cfgw-open-road.vercel.app/",
  },
  {
    title: "Hunger Stone",
    subtitle: "Next.js and Vercel",
    description:
      "Hunger Stone delivers an interactive map with data visualizations to track surface water levels of rivers and lakes in North America. It also provides scientific research into climate science and drought-related news in fun manageable bite-size bits of information by providing links to actual science-backed sources",
    image:
      "https://static.vecteezy.com/system/resources/previews/002/268/321/original/work-in-progress-neon-signs-style-text-free-vector.jpg",
    link: "https://github.com/jalbaral/hunger-stone-V2",
  },
  {
    title: "This Project is a work in-progress",
    subtitle: "C++",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius? Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
    image:
      "https://static.vecteezy.com/system/resources/previews/002/268/321/original/work-in-progress-neon-signs-style-text-free-vector.jpg",
    link: "",
  },
];

export const testimonials = [
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://randomuser.me/api/portraits/men/1.jpg",
    name: "Jesse Hicks",
    company: "Zoozle",
  },
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://randomuser.me/api/portraits/men/94.jpg",
    name: "Ruben Alvarez",
    company: "Dooble.io",
  },
];

export const skills = [
  "JavaScript",
  "React",
  "Redux",
  "PostgresSQL",
  "Sequelize",
  "Next.js",
  "Node.js",
  "Mapbox GL JS",
  "Firebase",
  "Express",
  "Tailwind",
  "Bootstrap",
];



// WEBPACK FOOTER //
// ./src/data.js